import { render } from "./UserManuelPage.vue?vue&type=template&id=f817010c"
import script from "./UserManuelPage.vue?vue&type=script&lang=js"
export * from "./UserManuelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__